<template>
  <div>

    <pageHeader :headerIcon="'doctor'"
                :headerText="$t('doctors')"
                :haveFilterInput="false">
    </pageHeader>

    <div class="ui grid" style="padding-top: 20px;">
      <div class="four wide column">
        <div class="ui vertical secondary pointing menu" style="width: 100%">
          <a class="item"
             :class="{ active: currentTab === tabs.first }"
             @click="currentTab = tabs.first">
            {{ $t('current') }}
          </a>

          <a class="item" :class="{ active: currentTab === tabs.second }"
             @click="currentTab = tabs.second">
            {{ $t('archived') }}
          </a>

          <a class="item" :class="{ active: currentTab === tabs.third }"
             @click="currentTab = tabs.third">
            {{ $t('all') }}
          </a>
        </div>
      </div>
      <div class="twelve wide column">
        <div v-if="loading" class="ui active centered inline loader">
          <div class="ui text loader">{{ $t('loading') }}...</div>
        </div>
        <div class="ui two columns grid" v-if="!loading && getDoctors().length">
          <div 
            class="column" 
            v-for="doctor in getDoctors()" 
            v-if="getDoctors().length && (isAdmin() || isMine(doctor.user.id))" 
            :key="doctor.id"
          >
            <div class="ui raised link fluid stackable card"
                 @click="navigateTo('Show_Doctor', { key: 'params', value: { id: doctor.id } })" >
              <div class="content">
                <img class="right floated mini ui image image-size"
                     src="~@/assets/image.png"
                     v-if="doctor.album.images.length < 1" />
                <img class="right floated mini ui image image-size"
                     :src="getImage(doctor.album)"
                     v-else />

                <div class="header" style="display:flex; align-items:center">
                  <div id="circle" :class="{ 'red-cirle': doctor.deleted_at }"></div>
                  {{ doctor.user.name }}
                </div>

                <div class="description">
                  <strong> {{ $t('email') }}: </strong> {{ doctor.user.email }}
                </div>
                <div class="description">
                  <strong> {{ $t('mobile') }}: </strong> {{ doctor.user.mobile }}
                </div>
                <div class="description">
                  <strong> {{ $t('specialization') }}: </strong> {{ doctor.specialization.name }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ui placeholder segment" style="margin-bottom: 50px"
             v-if="!loading && !getDoctors().length">
          <div class="ui icon header" style="color: #092442">
            <i class="dont icon"></i>
            {{ $t('thereIsNoArchivedDoctorYet') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  data () {
    return {
      loading: true,
      doctors: [],
      tabs: {
        first: 'current',
        second: 'archived',
        third: 'all'
      },
      currentTab: 'current'
    }
  },
  mounted () {
    this.$http.get('doctors').then(response => {
      this.doctors = response.data
      this.loading = false
    })
  },
  computed: {
  },
  methods: {
    getImage (album) {
      return album.images[album.images.length - 1].picture.url
    },
    getDoctors () {
      if (this.currentTab === this.tabs.first) {
        return window._.filter(this.doctors, doctor => {
          return !doctor.deleted_at
        })
      } else if (this.currentTab === this.tabs.second) {
        return window._.filter(this.doctors, doctor => {
          return doctor.deleted_at
        })
      } else if (this.currentTab === this.tabs.third) {
        return this.doctors
      }
    }
  }
}
</script>
<style scoped>
  .padding-header {
    padding-bottom: 15px;
  }
  .red-cirle {
    background-color: red !important;
  }
  .image-size {
    height: 30px !important;
    object-fit: contain;
  }
</style>



// WEBPACK FOOTER //
// src/components/doctors/Doctors.vue